/** Redux Packages. */
import { configureStore } from '@reduxjs/toolkit';
import socketSlice from 'shared/store/slices/socketStatusSlice';

import tabValueSlice from 'shared/store/slices/tabValueSlice';
import progressValueSlice from 'shared/store/slices/progressValueSlice';
import completeDateWindowSlice from 'shared/store/slices/completeDateWindowSlice';

import selectionSlice from 'shared/store/slices/selectionSlice';

import filterViewSlice from 'shared/store/slices/filterViewSlice';
import filterViewListSlice from 'shared/store/slices/filterViewListSlice';

import todoListSlice from 'shared/store/slices/todoListSlice';
import shipmentTodoSlice from 'shared/store/slices/shipmentTodoSlice';
import historySlice from 'shared/store/slices/historySlice';
import statusEditorSlice from 'shared/store/slices/statusEditorSlice';

import oimShipmentFormSlice from 'shared/store/slices/oim-newShipmentSlice';
import oimMainUpdateSlice from 'shared/store/slices/oim-mainUpdateSlice';
import oimHblUpdateSlice from 'shared/store/slices/oim-hblUpdateSlice';
import oimContainerUpdateSlice from 'shared/store/slices/oim-containerUpdateSlice';
import oimContainerAliasUpdateSlice from 'shared/store/slices/oim-containerAliasUpdateSlice';
import oimPresetUpdateSlice from 'shared/store/slices/oim-presetUpdateSlice';
import oimStatusUpdateSlice from 'shared/store/slices/oim-statusUpdateSlice';
import oimRateUpdateSlice from 'shared/store/slices/oim-rateUpdateSlice';
import oimCommentUpdateSlice from 'shared/store/slices/oim-commentUpdateSlice';
import oimDisputeUpdateSlice from 'shared/store/slices/oim-disputeUpdateSlice';

import oexShipmentFormSlice from 'shared/store/slices/oex-newShipmentSlice';
import oexMainUpdateSlice from 'shared/store/slices/oex-mainUpdateSlice';
import oexHblUpdateSlice from 'shared/store/slices/oex-hblUpdateSlice';
import oexContainerUpdateSlice from 'shared/store/slices/oex-containerUpdateSlice';
import oexPresetUpdateSlice from 'shared/store/slices/oex-presetUpdateSlice';
import oexStatusUpdateSlice from 'shared/store/slices/oex-statusUpdateSlice';
import oexRateUpdateSlice from 'shared/store/slices/oex-rateUpdateSlice';
import oexCommentUpdateSlice from 'shared/store/slices/oex-commentUpdateSlice';
import oexDisputeUpdateSlice from 'shared/store/slices/oex-disputeUpdateSlice';

import aimNewShipmentSlice from 'shared/store/slices/aim-newShipmentSlice';
import aimMainUpdateSlice from 'shared/store/slices/aim-mainUpdateSlice';
import aimHblUpdateSlice from 'shared/store/slices/aim-hblUpdateSlice';
import aimContainerUpdateSlice from 'shared/store/slices/aim-containerUpdateSlice';
import aimPresetUpdateSlice from 'shared/store/slices/aim-presetUpdateSlice';
import aimStatusUpdateSlice from 'shared/store/slices/aim-statusUpdateSlice';
import aimRateUpdateSlice from 'shared/store/slices/aim-rateUpdateSlice';
import aimCommentUpdateSlice from 'shared/store/slices/aim-commentUpdateSlice';
import aimDisputeUpdateSlice from 'shared/store/slices/aim-disputeUpdateSlice';

import aexNewShipmentSlice from 'shared/store/slices/aex-newShipmentSlice';
import aexMainUpdateSlice from 'shared/store/slices/aex-mainUpdateSlice';
import aexHblUpdateSlice from 'shared/store/slices/aex-hblUpdateSlice';
import aexContainerUpdateSlice from 'shared/store/slices/aex-containerUpdateSlice';
import aexPresetUpdateSlice from 'shared/store/slices/aex-presetUpdateSlice';
import aexStatusUpdateSlice from 'shared/store/slices/aex-statusUpdateSlice';
import aexRateUpdateSlice from 'shared/store/slices/aex-rateUpdateSlice';
import aexCommentUpdateSlice from 'shared/store/slices/aex-commentUpdateSlice';
import aexDisputeUpdateSlice from 'shared/store/slices/aex-disputeUpdateSlice';

import truckingNewShipmentSlice from 'shared/store/slices/trucking-newShipmentSlice';
import truckingMainUpdateSlice from 'shared/store/slices/trucking-mainUpdateSlice';
import truckingBolUpdateSlice from 'shared/store/slices/trucking-bolUpdateSlice';
import truckingPresetUpdateSlice from 'shared/store/slices/trucking-presetUpdateSlice';
import truckingStatusUpdateSlice from 'shared/store/slices/trucking-statusUpdateSlice';
import truckingRateUpdateSlice from 'shared/store/slices/trucking-rateUpdateSlice';
import truckingCommentUpdateSlice from 'shared/store/slices/trucking-commentUpdateSlice';
import truckingDisputeUpdateSlice from 'shared/store/slices/trucking-disputeUpdateSlice';

import tradePartnerSlice from 'shared/store/slices/tradePartnerSlice';
import presetNoteSlice from 'shared/store/slices/presetNoteSlice';

import routeSlice from 'shared/store/slices/routeSlice';
import newRouteSlice from 'shared/store/slices/newRouteSlice';
import rateTypeSlice from 'shared/store/slices/rateTypeSlice';
import statusMessageSlice from 'shared/store/slices/statusMessageSlice';
import rateManagementSlice from 'shared/store/slices/rateManagementSlice';

/** Duty Calculator feature-owned reducers (registered via the feature's public API). */
import { clientListReducer, itemCategoriesReducer } from 'features/duty-calculator';
import { packingListReducer } from 'features/shipments';

import snackBarSlice from 'shared/store/slices/snackBarSlice';

import taskboardSlice from 'shared/store/slices/taskboardSlice';

import accountingSlice from 'shared/store/slices/accountingUpdateSlice';

export const store = configureStore({
    reducer: {
        socketStatus: socketSlice,

        tabValueForm: tabValueSlice,
        progressValue: progressValueSlice,
        completeDateWindow: completeDateWindowSlice,
        mainTableSelectValue: selectionSlice,

        filterViewData: filterViewSlice,
        filterViewList: filterViewListSlice,

        todoList: todoListSlice,
        shipmentTodo: shipmentTodoSlice,
        historyList: historySlice,
        statusEditor: statusEditorSlice,

        oimNewShipmentForm: oimShipmentFormSlice,
        oimMainUpdateForm: oimMainUpdateSlice,
        oimHblUpdateForm: oimHblUpdateSlice,
        oimContainerUpdateForm: oimContainerUpdateSlice,
        oimContainerAliasUpdateForm: oimContainerAliasUpdateSlice,
        oimPresetUpdateForm: oimPresetUpdateSlice,
        oimStatusUpdateForm: oimStatusUpdateSlice,
        oimRateUpdateForm: oimRateUpdateSlice,
        oimCommentUpdateForm: oimCommentUpdateSlice,
        oimDisputeUpdateForm: oimDisputeUpdateSlice,

        oexNewShipmentForm: oexShipmentFormSlice,
        oexMainUpdateForm: oexMainUpdateSlice,
        oexHblUpdateForm: oexHblUpdateSlice,
        oexContainerUpdateForm: oexContainerUpdateSlice,
        oexPresetUpdateForm: oexPresetUpdateSlice,
        oexStatusUpdateForm: oexStatusUpdateSlice,
        oexRateUpdateForm: oexRateUpdateSlice,
        oexCommentUpdateForm: oexCommentUpdateSlice,
        oexDisputeUpdateForm: oexDisputeUpdateSlice,

        aimNewShipmentForm: aimNewShipmentSlice,
        aimMainUpdateForm: aimMainUpdateSlice,
        aimHblUpdateForm: aimHblUpdateSlice,
        aimContainerUpdateForm: aimContainerUpdateSlice,
        aimPresetUpdateForm: aimPresetUpdateSlice,
        aimStatusUpdateForm: aimStatusUpdateSlice,
        aimRateUpdateForm: aimRateUpdateSlice,
        aimCommentUpdateForm: aimCommentUpdateSlice,
        aimDisputeUpdateForm: aimDisputeUpdateSlice,

        aexNewShipmentForm: aexNewShipmentSlice,
        aexMainUpdateForm: aexMainUpdateSlice,
        aexHblUpdateForm: aexHblUpdateSlice,
        aexContainerUpdateForm: aexContainerUpdateSlice,
        aexPresetUpdateForm: aexPresetUpdateSlice,
        aexStatusUpdateForm: aexStatusUpdateSlice,
        aexRateUpdateForm: aexRateUpdateSlice,
        aexCommentUpdateForm: aexCommentUpdateSlice,
        aexDisputeUpdateForm: aexDisputeUpdateSlice,

        truckingNewShipmentForm: truckingNewShipmentSlice,
        truckingMainUpdateForm: truckingMainUpdateSlice,
        truckingBolUpdateForm: truckingBolUpdateSlice,
        truckingPresetUpdateForm: truckingPresetUpdateSlice,
        truckingStatusUpdateForm: truckingStatusUpdateSlice,
        truckingRateUpdateForm: truckingRateUpdateSlice,
        truckingCommentUpdateForm: truckingCommentUpdateSlice,
        truckingDisputeUpdateForm: truckingDisputeUpdateSlice,

        tradePartnerForm: tradePartnerSlice,
        presetNoteForm: presetNoteSlice,

        routes: routeSlice,
        newRouteList: newRouteSlice,
        rateTypes: rateTypeSlice,
        statusMessages: statusMessageSlice,
        rateManagementData: rateManagementSlice,

        clientList: clientListReducer,
        itemCategories: itemCategoriesReducer,

        snackBar: snackBarSlice,
        packingList: packingListReducer,
        taskboard: taskboardSlice,
        accountingList: accountingSlice,
    },
});
